import {computeSingleInputBoundaryIndex} from 'notebook/tables/store/logic/TableSingleInputsLogic';
import {createTableModelSelector} from 'notebook/tables/store/selectors/util/SelectorCreators';
import {TableEditableStore, TableEditableVolatileProps} from 'notebook/tables/store/TableStore';

export interface TableSingleInputsModel {
  /**
   * The column index of the first non-single-input column.
   * Returns null if there are no single input columns.
   */
  boundaryIndex: number | null;

  /*
  TODO(BNCH-146929): Future properties to be added as logic is transitioned out of TableEditable:
  isVisible: boolean; // From _isSingleInputVisible()
  groupHeight: number; // From _getSingleInputGroupHeight()
  slices: {
    start: number | null; // From getTableSlices()
    end: number | null;
  };
  effectiveSlices: {
    start: number; // From getEffectiveTableSlices()
    end: number;
  };
  sliceWidthPx: number; // From getSliceWidthPx()
  */
}

export function createBoundaryIndexSelector(
  volatilePropsSelector: (store: TableEditableStore) => TableEditableVolatileProps
): (store: TableEditableStore) => number | null {
  return createTableModelSelector([(store) => volatilePropsSelector(store).table], (table) =>
    computeSingleInputBoundaryIndex(table)
  );
}

export function createTableSingleInputsSelector(
  volatilePropsSelector: (store: TableEditableStore) => TableEditableVolatileProps
): (store: TableEditableStore) => TableSingleInputsModel {
  return createTableModelSelector([(store) => volatilePropsSelector(store).table], (table) => ({
    boundaryIndex: computeSingleInputBoundaryIndex(table),
  }));
}
